<!--
 * @Author: MouXiaowei
 * @Date: 2022-11-02 09:24:02
 * @Description: 加油金领取记录
-->
<template>
    <div class="record-box">
        <div v-for="(item, index) in dataSource" :key="index">
          <div class="item-view">
            <div class="item-left">
              <div class="item-left-title">{{item.typeDesc}}</div>
              <div class="item-left-time">{{item.luckTime}}</div>
            </div>
            <div class="item-right">
              <span v-if="item.amountDesc && item.amountDesc.includes('+')" class="item-right-red">{{item.amountDesc}}</span>
              <span v-else class="item-right-black">{{item.amountDesc}}</span>
            </div>
          </div>
          <div v-if="index < dataSource.length" class="line-view"></div>
        </div>
    </div>
  </template>
<script>
import { queryOilLucKDrawDetail } from '@/api/active'
export default {
  name: 'refuelingMoneyRecord',
  components: {
  },
  data () {
    return {
      dataSource: [] // 列表
    }
  },
  mounted () {
    this.queryOilLucKDrawDetail()
  },
  methods: {
    queryOilLucKDrawDetail () {
      const query = {
      }
      queryOilLucKDrawDetail(query).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.dataSource = res.data.result
            }
          }
        }
      })
    }
  }
}
</script>
  <style lang="scss">
  .record-box {
    position: relative;
    overflow: hidden;
    width: 100%;
    min-height: 100vh;
    background-color: #f6f6f6;
  }

  .line-view {
    margin-left: 15px;
    height: 1px;
    background-color: #F1F1F1;;
  }

  .item-view {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 55px;
    background-color: #fff;

    .item-left {
      margin-left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      .item-left-title {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      .item-left-time {
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        color: #757575;
        line-height: 17px;
      }
    }

    .item-right {
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .item-right-red {
        font-weight: 500;
        font-size: 14px;
        color: #FF7519;
        line-height: 20px;
      }
      .item-right-black {
        font-weight: 500;
        font-size: 14px;
        color: #282828;
        line-height: 20px;
      }
    }
  }

  </style>
